/** @prettier */
import ReactApexChart from 'react-apexcharts';

//type import
import {GraphDataRange, GraphTargetType} from '../Type/TypeDef';
import {aggregationQtonHyozanEnergyGraphSetting} from './graph/setting/barLineMixed/aggregationQtonHyozanBarLineMixedGraphSettings';
import {useTranslation} from 'react-i18next';

/**
 * 熱量グラフ
 * @param props props
 * @returns JSX
 */
const BarLineMixedChartGraph = (props: {
  graphTarget: GraphTargetType; //表示する対象
  xLabel: string[]; //X軸のラベル
  dateRange: GraphDataRange; //データ取得範囲
  csvFileNameDate: string; //CSVファイルの名前（日付部分）
  csvFileNameTarget: string; //CSVファイルの名前（サイトの名前 + グラフの対象の名前）
  barGraphData: ApexAxisChartSeries['0']['data']; //棒グラフデータ
  lineGraphData: ApexAxisChartSeries['0']['data']; //折れ線グラフデータ
  comparisonBarGraphData?: ApexAxisChartSeries['0']['data']; //比較用棒グラフデータ
  comparisonLineGraphData?: ApexAxisChartSeries['0']['data']; //比較用折れ線グラフデータ
}) => {
  const trans = useTranslation().t; //翻訳関数

  //比較データが存在しない場合は熱量グラフ、比較データが存在する場合は熱量比較グラフを表示する。
  const chartArg = aggregationQtonHyozanEnergyGraphSetting({
    xLabel: props.xLabel,
    dateRange: props.dateRange,
    csvFileNameDate: props.csvFileNameDate,
    csvFileNameTarget: props.csvFileNameTarget,
    energyGraphData: props.barGraphData,
    copGraphData: props.lineGraphData,
    comparisonEnergyGraphData:
      props.comparisonBarGraphData === undefined
        ? []
        : props.comparisonBarGraphData,
    comparisonCopGraphData:
      props.comparisonLineGraphData === undefined
        ? []
        : props.comparisonLineGraphData,
    trans: trans,
  });

  if (chartArg === null) return <></>;
  return (
    <ReactApexChart
      options={chartArg.options}
      series={chartArg.series}
      type="line"
      height="75%"
    />
  );
};

export default BarLineMixedChartGraph;
